import { useEffect, useState } from 'react';

import Chip from '@mui/material/Chip';

import { chamaApi } from 'api/chama';
import { getAuthUser } from 'utils/auth';

export default function RoleBadge() {
  const user = getAuthUser();
  const [label, setLabel] = useState(user?.is_super_admin ? 'Super Admin' : null);

  useEffect(() => {
    if (user?.is_super_admin) return;

    chamaApi
      .myRoles()
      .then((data) => {
        const roles = Array.isArray(data?.roles) ? data.roles : [];
        if (roles.includes('admin')) setLabel('Admin');
        else if (roles.includes('treasurer')) setLabel('Treasurer');
        else if (roles.length > 0) setLabel(roles[0].charAt(0).toUpperCase() + roles[0].slice(1));
        else setLabel('Member');
      })
      .catch(() => setLabel(null));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!label) return null;

  return (
    <Chip
      label={label}
      size="small"
      color={label === 'Super Admin' ? 'primary' : 'default'}
      variant={label === 'Super Admin' ? 'filled' : 'outlined'}
      sx={{ fontWeight: 600 }}
    />
  );
}
